import React from "react";
import { collagePages } from "../mock";
import { useSiteData } from "../context/SiteDataContext";
import { uniqueLabels } from "../lib/contentCollections";
import { getSection, imageStyle, renderMultilineText, sectionStyle } from "../lib/sectionStyles";
import SafeImage from "../components/SafeImage";

const BrandStatement = () => {
  const { siteSections } = useSiteData();
  const section = getSection(siteSections, "home", "home.writing-beats", {
    eyebrow: "Section 06 - The Brief",
    title: "I write the region into the room - before someone else writes it out.",
    body:
      "High-stakes, real-time storytelling on the cultural forces shaping music, identity, and style across the Middle East. Cover features. Cover stories. The byline that knows the room.",
    caption: "This is YUNG // Pitches & Ideas",
    imageUrl: collagePages.thisisyung,
    imageAlt: "This Is YUNG editorial spreads",
    imagePosition: "center",
    imageFit: "cover",
    content: { badges: ["Cover Stories", "Long-reads", "Profiles", "Edits", "Cultural Commentary"] },
  });

  if (!section) return null;
  const badges = uniqueLabels(section.content?.badges);

  return (
    <section className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20 md:py-28" style={sectionStyle(section)}>
      <div className="grid grid-cols-12 gap-8 md:gap-12 items-center">
        <div className="col-span-12 md:col-span-7">
          <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-[var(--ink-soft)]">
            {section.eyebrow}
          </span>
          <h2 className="mt-3 font-editorial leading-[1.02] tracking-tight text-5xl md:text-6xl lg:text-7xl">
            {renderMultilineText(section.title)}
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-[var(--ink-soft)] max-w-2xl">
            {renderMultilineText(section.body)}
          </p>
          {badges.length ? (
            <div className="mt-8 flex flex-wrap gap-2">
              {badges.map((badge) => (
                <span
                  key={badge}
                  className="font-mono text-[11px] tracking-[0.25em] uppercase border border-[var(--ink)] px-3 py-1.5"
                >
                  {badge}
                </span>
              ))}
            </div>
          ) : null}
        </div>

        <div className="col-span-12 md:col-span-5 relative">
          <span className="tape -top-4 left-10 -rotate-3" />
          <SafeImage
              containerClassName="border-4 border-[var(--ink)] overflow-hidden"
              src={section.imageUrl || collagePages.thisisyung}
              fallbackSrc={collagePages.thisisyung}
              alt={section.imageAlt || "This Is YUNG editorial spreads"}
              loading="lazy"
              width="940"
              height="705"
              className="w-full h-auto object-cover"
              style={imageStyle(section)}
            />
          <p className="absolute -bottom-5 -left-3 rotate-[-3deg] font-hand text-2xl text-[var(--red-deep)] bg-[var(--paper)] px-3 py-1 border border-[var(--ink)] shadow-[2px_2px_0_var(--ink)]">
            {section.caption}
          </p>
        </div>
      </div>
    </section>
  );
};

export default BrandStatement;
